module.exports = __webpack_public_path__ + "img/in-sight-in-mind-logo.de1418d9.png";